export default "__VITE_ASSET__DRULejVm__"